import React from "react";
import { Props } from "./types";
import { Sort } from "./sort";
import { Task } from "./task";
import {
  sortByDefaultOrder,
  sortByNameAscending,
  sortByNameDescending,
  sortByStatusAscending,
  sortByStatusDescending,
  sortByDateAscending,
  sortByDateDescending,
} from "./utils";
import styles from "./styles.scss";

function Tasks({ tasks, areLate, constraints }: Props) {
  const [sort, setSort] = React.useState({
    isNameAscending: false,
    isNameDescending: false,
    isStatusAscending: false,
    isStatusDescending: false,
    isEndDateAscending: false,
    isEndDateDescending: false,
  });

  return (
    <div className={styles.tasks}>
      <Sort sort={sort} setSort={setSort} />
      <div className={styles.list}>
        {[...tasks]
          .sort(
            sort.isNameAscending
              ? sortByNameAscending
              : sort.isNameDescending
                ? sortByNameDescending
                : sort.isStatusAscending
                  ? sortByStatusAscending
                  : sort.isStatusDescending
                    ? sortByStatusDescending
                    : sort.isEndDateAscending
                      ? sortByDateAscending
                      : sort.isEndDateDescending
                        ? sortByDateDescending
                        : sortByDefaultOrder,
          )
          .map((task) => (
            <Task
              key={task.uuid}
              task={task}
              isLate={areLate}
              constraints={constraints}
            />
          ))}
      </div>
    </div>
  );
}

export { Tasks };
